import React from 'react'
import { Link } from "react-router-dom";

export default function Navbar() {
  return (
    <>
      <section className="navigation">
    <div className="container">
        <div className="row">
            <div className="col-md-12">
                <nav className="navbar navbar-expand-sm mynav">
                    <Link className="navbar-brand" to="/"><img src="/assets/img/logo.png" alt="Logo"/></Link>
                    <button className="navbar-toggler d-lg-none" type="button" data-toggle="collapse"><img src="/assets/img/menu-ic.png" alt="" /></button>
                    <div className="navbar-collapse" id="menuControl">
                        <div id="menuClose" className="closeMenu"><img src="/assets/img/close.png" alt="" /></div>
                        <ul className="navbar-nav">
                            <li className="nav-item active">
                                <Link className="nav-link" to="/"><svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="100" height="100" viewBox="0 0 50 50">
                                <path d="M 25 1.0507812 C 24.7825 1.0507812 24.565859 1.1197656 24.380859 1.2597656 L 1.3808594 19.210938 C 0.95085938 19.550938 0.8709375 20.179141 1.2109375 20.619141 C 1.5509375 21.049141 2.1791406 21.129062 2.6191406 20.789062 L 4 19.710938 L 4 46 C 4 46.55 4.45 47 5 47 L 19 47 L 19 29 L 31 29 L 31 47 L 45 47 C 45.55 47 46 46.55 46 46 L 46 19.710938 L 47.380859 20.789062 C 47.570859 20.929063 47.78 21 48 21 C 48.3 21 48.589063 20.869141 48.789062 20.619141 C 49.129063 20.179141 49.049141 19.550938 48.619141 19.210938 L 25.619141 1.2597656 C 25.434141 1.1197656 25.2175 1.0507812 25 1.0507812 z M 35 5 L 35 6.0507812 L 41 10.730469 L 41 5 L 35 5 z"></path>
                                </svg></Link>
                            </li>
                            <li className="nav-item">
                                <Link className="nav-link" to="/AboutUs">About Us</Link>
                            </li>
                             <li className="nav-item dropdown">
                              <Link class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">Domestic Packages</Link>
                                <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
                                     <li><Link className="dropdown-item" to="/TravelPackagesCraftIndia/ladakh">Ladakh</Link></li>
                                     <li><Link className="dropdown-item" to="/TravelPackagesCraftIndia/kashmir">Kashmir</Link></li>
                                     <li><Link className="dropdown-item" to="/TravelPackagesCraftIndia/Andaman">Andaman</Link></li>
                                     <li><Link className="dropdown-item" to="/TravelPackagesCraftIndia/Kerala">Kerala</Link></li>
                                     <li><Link className="dropdown-item last" to="/TravelPackagesCraftIndia/Rajasthan">Rajasthan</Link></li>
                                </ul>
                             </li>
                             <li className="nav-item dropdown">
                              <Link class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">International Packages</Link>
                                <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
                                     <li><Link className="dropdown-item" to="/TravelPackagesCraft/Bali">Bali</Link></li>
                                     <li><Link className="dropdown-item" to="/TravelPackagesCraft/Singapore">Singapore</Link></li>
                                     <li><Link className="dropdown-item" to="/TravelPackagesCraft/Thailand">Thailand</Link></li>
                                     <li><Link className="dropdown-item" to="/TravelPackagesCraft/Vietnam">Vietnam</Link></li>
                                     <li><Link className="dropdown-item" to="/TravelPackagesCraft/Srilanka">Sri Lanka</Link></li>
                                     <li><Link className="dropdown-item" to="/TravelPackagesCraft/Maldives">Maldives</Link></li>
                                     <li><Link className="dropdown-item last" to="/TravelPackagesCraft/Dubai">Dubai</Link></li>
                                </ul>
                             </li>
                            {/*<li className="nav-item">
                                <Link className="nav-link" to="#">Featured</Link>
                            </li>
                            <li className="nav-item">
                                <Link className="nav-link" to="#">Contact Us</Link>
                            </li> */}
                            <li className="nav-item">
                                <Link className="nav-link" to="tel:8766234500"><img className="phone" src="/assets/img/phone.webp" alt="" /> 8766234500</Link>
                            </li>
                              <li className="nav-item">
                                <Link target='_blank' className="nav-link" to="https://api.whatsapp.com/send/?phone=%2B918766234500&text=Hi+which+destination+you+want+to+unlock&type=phone_number&app_absent=0"> <img src="/assets/img/whatsapp.webp" alt="" /> 8766234500</Link>
                            </li>
                        </ul>  
                       
                    </div> 
                    
                </nav> 
                      <div className='contactInfo'>
                           
                        </div> 
                
            </div>
        </div>
    </div>
</section>
    </>
  )
}

